import React, { useRef, useState } from 'react';
import { videoPoster_zh } from '../../assets/icons';
import geekcode_video from '../../assets/video/geekcode_cloud_zh.mp4';
import './style.less';

const VideoDemo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handlePlayClick = () => {
    if (!videoRef.current) return;
    setHasError(false);
    const playPromise = videoRef.current.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false));
    } else {
      setIsPlaying(true);
    }
  };

  const handleRetry = () => {
    setHasError(false);
    if (videoRef.current) {
      videoRef.current.load();
    }
  };

  return (
    <div className="video-demo">
      <div className="video-header">
        <span className="section-eyebrow">实机演示 · LIVE WALKTHROUGH</span>
        <h2>一分钟了解 IDEVault 云端研发全流程</h2>
        <p>从选择项目共享模板、秒级拉起云端工作间，到浏览器编码调试与 AI 智能体协同，全流程开箱即用</p>
      </div>

      <div className="video-frame cloud-collab-card">
        <div className="frame-topbar">
          <div className="frame-dots" aria-hidden="true">
            <span className="dot red" />
            <span className="dot amber" />
            <span className="dot green" />
          </div>
          <div className="frame-url">
            https://console.geekcode.cloud/workspaces/ws-core-payment
          </div>
          <div className="frame-badges">
            <span>1080P HD</span>
          </div>
        </div>

        <div className="video-container">
          {!hasError ? (
            <>
              <video
                ref={videoRef}
                controls={isPlaying}
                poster={videoPoster_zh}
                className="demo-video"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onEnded={() => setIsPlaying(false)}
                onError={() => setHasError(true)}
                preload="metadata"
              >
                <source src={geekcode_video} type="video/mp4" />
                您的浏览器不支持视频播放
              </video>

              {!isPlaying && (
                <button
                  type="button"
                  className="play-overlay-btn"
                  onClick={handlePlayClick}
                  aria-label="播放实机演示视频"
                >
                  <span className="play-circle">
                    <span className="play-triangle" aria-hidden="true">▶</span>
                  </span>
                  <span className="play-text">播放实机演示</span>
                </button>
              )}
            </>
          ) : (
            <div className="video-error-fallback" role="alert">
              <div className="error-title">演示视频资源加载失败</div>
              <p className="error-desc">
                当前网络环境可能限制了媒体加载，您可以点击重试或直接登录控制台体验。
              </p>
              <div className="error-actions">
                <button type="button" className="retry-btn" onClick={handleRetry}>
                  ↻ 重新加载视频
                </button>
                <a
                  className="fallback-console-link"
                  href="https://console.geekcode.cloud/login/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  直接登录控制台 ↗
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoDemo;
